import Vue from 'vue';
import { Button,Table,TableColumn,Form,FormItem,Tag,Popconfirm,Input,Card,Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tag);
Vue.use(Popconfirm);
Vue.use(Input);
Vue.use(Card);
// 新增：挂载全局消息提示$message（登录页成功/失败提示用到）
Vue.prototype.$message = Message;